export default {
  primary: 'rgb(15, 230, 252)',
  background: '#fff',
  secondaryBackground: '#fff',
  primaryText: '#000',
  secondaryText: '#ffffff',
  boxShadow: 'rgb(15 230 252 / 30%) 0px 5px 10px',
}